/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'organization-data-diagram': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M8.125 18.75a6.875 6.875 0 110-13.75c.345 0 .625.28.625.625v5.625h5.625c.345 0 .625.28.625.625a6.875 6.875 0 01-6.875 6.875zM7.5 6.287a5.625 5.625 0 106.213 6.213H8.75c-.69 0-1.25-.56-1.25-1.25V6.287zm10 2.463h-5.625c-.69 0-1.25-.56-1.25-1.25V1.875c0-.345.28-.625.625-.625a6.875 6.875 0 016.875 6.875c0 .345-.28.625-.625.625zM11.875 7.5h4.962a5.625 5.625 0 00-4.962-4.963V7.5z"/>'
  }
})
